export function checkRules(username= "") {
  return {
    address: [_requiredField, _maxLength200],
    email: [_requiredField, _emailConstraint],
    password: [
      _hasUppercase,
      _hasLowercase,
      _hasNumber,
      _hasSpecialChar,
      _notContainUsername(username),
    ],
  };
}

let _requiredField = (v) => !!v || 'Required';
let _maxLength200 = (v) =>
  (!!v && v.length <= 200) || 'Length cannot be greater than 200';
let _emailConstraint = (v) => {
  if (v) {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(v) || 'Invalid e-mail.';
  } else {
    return true;
  }
};


let _hasUppercase = (v) =>
  !v || /[A-Z]/.test(v) || 'Must have at least one uppercase letter.';
let _hasLowercase = (v) =>
  !v || /[a-z]/.test(v) || 'Must have at least one lowercase letter.';
let _hasNumber = (v) =>
  !v || /\d/.test(v) || 'Must have at least one number.';
let _hasSpecialChar = (v) =>
  !v ||
  /[^A-Za-z0-9]/.test(v) ||
  'Must have at least one special character.';

// username restriction (need to pass username dynamically)
let _notContainUsername = (username) => (v) => {
  if (!v || !username) return true;

  const isPhone = /^\d+$/.test(username);
  if (isPhone) {
    return !v.includes(username) || 'Password must not contain your phone number.';
  } else {
    // split username into words, check each word
    const words = username.toLowerCase().split(/\s+/); 
    const passwordLower = v.toLowerCase();

    const containsWord = words.some(word => passwordLower.includes(word));
    return !containsWord || 'Password must not contain any part of your username.';
  }
};

